<shared-online-menu-nav-for-desktop *ngIf="!isMobile"></shared-online-menu-nav-for-desktop>
<shared-online-menu-nav-for-mobile [delayScroll]="delayScroll" *ngIf="isMobile"></shared-online-menu-nav-for-mobile>